import RequesterV1 from "@/components/api/v1/requester.js";

const rootPath = "agro_exporter/finances/harvested_batch_outcomes";

export default {
  fetchAgroExporterProcess(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `${rootPath}/${agro_exporter_id}/show_process/${agro_exporter_process_id}`
    );
  },

  fetchCurrencies(agro_exporter_id) {
    return RequesterV1.get(
      `${rootPath}/${agro_exporter_id}/manage_org_invoice/fetch_currencies`
    );
  },
  fetchExporterProcessCropPackages(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `${rootPath}/${agro_exporter_id}/manage_org_invoice/fetch_exporter_process_crop_packages/${agro_exporter_process_id}`
    );
  },
  fetchHarvestedBatches(agro_exporter_id, agro_exporter_process_id, org_invoice_id) {
    return RequesterV1.get(
      `${rootPath}/${agro_exporter_id}/manage_org_invoice/fetch_harvested_batches/${agro_exporter_process_id}/${org_invoice_id ?? ''}`
    );
  },
  fetchInvoiceIssuers(agro_exporter_id, producer_id) {
    return RequesterV1.get(
      `${rootPath}/${agro_exporter_id}/manage_org_invoice/fetch_invoice_issuers/${producer_id}`
    );
  },
  fetchOrgInvoice(agro_exporter_id, org_invoice_id) {
    return RequesterV1.get(
      `${rootPath}/${agro_exporter_id}/manage_org_invoice/fetch_org_invoice/${org_invoice_id}`
    );
  },
  create(agro_exporter_id, org_invoice_params) {
    return RequesterV1.post(
      `${rootPath}/${agro_exporter_id}/manage_org_invoice/create`,
      { org_invoice: org_invoice_params }
    );
  },
  update(agro_exporter_id, org_invoice_id, org_invoice_params) {
    return RequesterV1.post(
      `${rootPath}/${agro_exporter_id}/manage_org_invoice/update/${org_invoice_id}`,
      { org_invoice: org_invoice_params }
    );
  },
  destroy(agro_exporter_id, org_invoice_id) {
    return RequesterV1.delete(
      `${rootPath}/${agro_exporter_id}/manage_org_invoice/destroy/${org_invoice_id}`
    );
  }
};
